// extracted by mini-css-extract-plugin
export default {"formWrapper":"SearchForm_formWrapper__hZioc","form":"SearchForm_form__o80os","separator":"SearchForm_separator__IIQSY"};